// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productDetailsActionsStyles } from "@pace/App/Widgets/ProductDetails/ProductDetailsActions";
import IconEmail from "@pace/XDL/Icons/IconEmail";
import IconPrint from "@pace/XDL/Icons/IconPrint";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productDetailsActionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 15px;
    `,
};

productDetailsActionsStyles.shareContainer = {
    css: css`
        display: flex;
        gap: 24px;
        justify-content: end;
        align-items: center;
        height: 17px;
    `,
};

productDetailsActionsStyles.shareLink = {
    link: createLinkIconStyles(IconEmail, {
        typographyProps: {
            size: 12,
            lineHeight: "13px",
            weight: fontConfig.weight.bold,
        },
        icon: {
            position: "left",
        },
    }),
};

productDetailsActionsStyles.printLink = {
    ...createLinkIconStyles(IconPrint, {
        typographyProps: {
            size: 12,
            lineHeight: "13px",
            weight: fontConfig.weight.bold,
        },
        icon: {
            position: "left",
        },
    }),
};

productDetailsActionsStyles.noticeContainer = {
    css: css`
        margin-bottom: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        &&&& {
            padding: 8px;
            background-color: ${color("common.ui11")};
        }
        ${IconWrapper} {
            color: ${color("common.ui16")};
            opacity: 0.5;
        }
        ul {
            padding-left: 15px;
            font-size: 10px;
            line-height: 12px;
            margin: 0;
        }
    `,
};

productDetailsActionsStyles.noticeHeader = {
    size: 10,
    lineHeight: "11px",
    weight: fontConfig.weight.bold,
    css: css`
        display: flex;
        gap: 4px;
        align-items: center;
    `,
};

productDetailsActionsStyles.loginNote = {
    variant: "h4",
    forwardAs: "span",
    css: css`
        margin: 0;
    `,
};

productDetailsActionsStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

productDetailsActionsStyles.productPriceAndActionsStyle = {
    productAvailabilityStyles: {
        messageGridItem: {
            width: 6,
        },
        actionsGridItem: {
            width: 6,
        },
        buttonsContainer: {
            css: css`
                ${xScreen("lt", "xs")} {
                    align-items: flex-end;
                }
            `,
        },
        messageLabel: {
            size: 13,
        },
    },
    replacementWrapper: {
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
};

productDetailsActionsStyles.noticeList = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

productDetailsActionsStyles.noticeItems = {
    css: css`
        font-size: 12px;
        line-height: 16px;
        && {
            margin: 0;
        }
    `,
};
